export default "__VITE_ASSET__D4MsS7sz__"